<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <!-- 主表单区域 -->
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="8">
            <a-form-item :label="$t('label.feedingLot')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select :placeholder="$t('label.pleaseSelectTheFeedingLot')" showSearch option-filter-prop="children"
                        v-decorator="['breedBatchCode',validatorRules.breedBatchCode]" @change="breedCodeChanged">
                <a-select-option
                  v-for="item in breedCodeList"
                  :key="item.breedCode"
                  :value="item.breedCode">
                  {{ item.breedCode+"|"+item.breedName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!--label="批次名称"-->
            <a-form-item :label="$t('label.flockName')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['breedBatchName']" :disabled="true" :placeholder="$t('label.pleaseEnterTheFlockName')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.breedingContract')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['conCode']" :disabled="true" :placeholder="$t('label.pleaseEnterTheBreedingContract')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.settlementDate')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date :placeholder="$t('label.pleaseSelectTheSettlementDate')"
                      v-decorator="['settleDate',{'initialValue': initDocDate, rules: validatorRules.settlementDate.rules}]"
                      :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.company')"  :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag v-decorator="['companyCode']" :disabled="true" :triggerChange="true" :placeholder="$t('label.pleaseSelectCompany')" dictCode="sys_depart,depart_name,org_code,org_category='1'" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.grower')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag v-decorator="['farmerCode']" :disabled="true" :triggerChange="true" :placeholder="$t('label.pleaseSelectGrower')"  dictCode="efs_md_farmer,name,code" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.contractType')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag v-decorator="['conType']" :disabled="true" :triggerChange="true" :placeholder="$t('label.pleaseSelectTheContractType')" dictCode="contact_type" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.dateOfSigning')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date :placeholder="$t('label.pleaseSelectTheDateOfSigning')"
                      :disabled="true"
                      v-decorator="['signDate']"
                      :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.billMaker')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag v-decorator="['applyUser']" :disabled="true" :triggerChange="true" :placeholder="$t('label.pleaseSelectThePersonWhoInvitesOrderMaking')" dictCode="sys_user,realname,username" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.species')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag v-decorator="['breedClassCode']" :disabled="true" :placeholder="$t('label.pleaseSelectStrain')" type="list"
                                 :trigger-change="true" :dictCode="dictBreedClassCode"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.breed')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag v-decorator="['breedVarietyCode']" :disabled="true" :placeholder="$t('label.pleaseSelectTheBreed')" type="list"
                                 :trigger-change="true" :dictCode="dictBreedVarietyCode"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.serviceGroup')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag v-decorator="['serviceGroup']" :disabled="true" :triggerChange="true" :placeholder="$t('label.pleaseSelectTheServiceGroup')" dictCode="sys_depart,depart_name,org_code,org_category='2'" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.cooperationModel')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['cooperMode', validatorRules.cooperMode]"
                                 :trigger-change="true"
                                 :disabled="true"
                                 dictCode="arch_cooper_mode"
                                 :placeholder="$t('label.pleaseSelectTheCooperationMode')" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.remarks')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!--<a-input v-decorator="['remarks']" placeholder="请输入备注"></a-input>-->
              <mtc-lang-popover :whetherLang="whetherLang('remarks')" :popLists="getMainTablePop('remarks')">
                <a-input
                  v-decorator="['remarks']"
                  :read-only="whetherLang('remarks')"
                  @click="isLangClick('remarks', true)"
                  :placeholder="$t('label.pleaseEnterANote')"
                ></a-input>
              </mtc-lang-popover>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
    <!-- 子表单区域 -->
    <a-tabs v-model="activeKey" @change="handleChangeTabs">
      <a-tab-pane :tab="$t('tabName.cull')" :key="refKeys[0]" :forceRender="true">
        <settle-out-list-form ref="settleOutListForm" @validateError="validateError"
                              :disabled="formDisabled"></settle-out-list-form>
      </a-tab-pane>
      <a-tab-pane :tab="$t('tabName.receipt')" :key="refKeys[1]" :forceRender="true">
        <settle-expend-list-from ref="settleExpendListFrom" @validateError="validateError"
                                 :disabled="formDisabled"></settle-expend-list-from>
      </a-tab-pane>
      <a-tab-pane :tab="$t('tabName.subsidyItem')" :key="refKeys[2]" :forceRender="true">
        <j-editable-table
          :ref="refKeys[2]"
          :loading="subsidyTable.loading"
          :columns="subsidyTable.columns"
          :dataSource="subsidyTable.dataSource"
          :maxHeight="300"
          :disabled="formDisabled"
          :rowNumber="true"
          :rowSelection="true"
          :actionButton="true"
          @valueChange="subsidyTableHandleValueChange"
        />
      </a-tab-pane>

      <a-tab-pane :tab="$t('tabName.expenseItem')" :key="refKeys[3]" :forceRender="true">
        <j-editable-table
          :ref="refKeys[3]"
          :loading="costTable.loading"
          :columns="costTable.columns"
          :dataSource="costTable.dataSource"
          :maxHeight="300"
          :disabled="formDisabled"
          :rowNumber="true"
          :rowSelection="true"
          :actionButton="true"
          @valueChange="costTableHandleValueChange"
        />
      </a-tab-pane>

      <a-tab-pane :tab="$t('tabName.penalty')" :key="refKeys[4]" :forceRender="true">
        <j-editable-table
          :ref="refKeys[4]"
          :loading="punishTable.loading"
          :columns="punishTable.columns"
          :dataSource="punishTable.dataSource"
          :maxHeight="300"
          :disabled="formDisabled"
          :rowNumber="true"
          :rowSelection="true"
          :actionButton="true"
          @valueChange="punishTableHandleValueChange"
        />
      </a-tab-pane>

      <a-tab-pane :tab="$t('tabName.settlement')" :key="refKeys[5]" :forceRender="true">
        <settle-settlement-list-from ref="settleSettlementListFrom" @validateError="validateError"
                                     :disabled="formDisabled"></settle-settlement-list-from>
      </a-tab-pane>
    </a-tabs>
  </a-spin>
</template>

<script>

    import pick from 'lodash.pick'
    import { getAction } from '@/api/manage'
    import { FormTypes, getRefPromise, VALIDATE_NO_PASSED, validateFormAndTables } from '@/utils/JEditableTableUtil'
    import { JEditableTableMixin } from '@/mixins/JEditableTableMixin'
    import { getBreedCodeData } from '@/api/api'
    import SettleOutListForm from './SettleOutListForm.vue'
    import SettleExpendListFrom from './SettleExpendListFrom.vue'
    import SettleSettlementListFrom from './SettleSettlementListFrom.vue'
    import moment from 'moment'

    export default {
        name: 'EfsStBreedSettleForm',
        mixins: [JEditableTableMixin],
        components: {
            SettleOutListForm,
            SettleExpendListFrom,
            SettleSettlementListFrom
        },
        data() {
            return {
                mainTable: 'efs_st_breed_settle',
                subTable: ['efs_st_breed_settle'],
                labelCol: {
                    xs: { span: 24 },
                    sm: { span: 6 },
                },
                wrapperCol: {
                    xs: { span: 24 },
                    sm: { span: 16 },
                },
                labelCol2: {
                    xs: { span: 24 },
                    sm: { span: 3 },
                },
                wrapperCol2: {
                    xs: { span: 24 },
                    sm: { span: 20 },
                },
                // 新增时子表默认添加几行空数据
                addDefaultRowNum: 1,
                validatorRules: {
                    settlementDate: {
                        rules: [
                            { required: true, message: this.$t('label.pleaseSelectTheSettlementDate') },
                        ]
                    },
                    breedBatchCode: {
                        rules: [
                            { required: true, message: this.$t('label.pleaseSelectTheFeedingLot') },
                        ]
                    },
                },
                breedCodeList: [],
                refKeys: ['settleOutList', 'settleExpendList', 'subsidyDetails', 'costDetails', 'punishDetails', 'settleSettlementList'],
                tableKeys: ['subsidyDetails', 'costDetails', 'punishDetails'],
                activeKey: 'settleSettlementList',
                settleSettlementListTable: {
                    loading: false,
                    dataSource: [],
                    columns: []
                },
                settleExpendListTable: {
                    loading: false,
                    dataSource: [],
                    columns: []
                },
                settleOutListTable: {
                    loading: false,
                    dataSource: [],
                    columns: []
                },
                // 补贴项
                subsidyTable: {
                    loading: false,
                    tableName: 'efs_st_breed_settle_subsidy',
                    dataSource: [],
                    columns: [
                        {
                            //title: '日期',
                            title: this.$t('tableHeader.date'),
                            key: 'postDate',
                            type: FormTypes.date,
                            width: '200px',
                            placeholder: this.$t('tip.pleaseSelect') + '${title}',
                        },
                        {
                            //title: '类别',
                            title: this.$t('tableHeader.category'),
                            key: 'subsidyType',
                            type: FormTypes.input,
                            width: '200px',
                            placeholder: this.$t('tip.pleaseInput') +'${title}',
                        },
                        {
                            //title: '项目',
                            title: this.$t('tableHeader.item'),
                            key: 'programs',
                            type: FormTypes.input,
                            width: '200px',
                            placeholder: this.$t('tip.pleaseInput') +'${title}',
                        },
                        {
                            //title: '金额',
                            title: this.$t('tableHeader.amount'),
                            key: 'price',
                            type: FormTypes.inputNumber,
                            width: '200px',
                            placeholder: this.$t('tip.pleaseInput') +'${title}',
                        },
                        {
                            title: this.$t('tableHeader.remarks'),
                            key: 'remarks',
                            type: FormTypes.input,
                            width: '200px',
                            placeholder: this.$t('tip.pleaseInput') +'${title}',
                        },
                    ]
                },

                //惩罚项
                punishTable: {
                    loading: false,
                    tableName: 'efs_st_breed_settle_punish',
                    dataSource: [],
                    columns: [
                        {
                            //title: '日期',
                            title: this.$t('tableHeader.date'),
                            key: 'postDate',
                            type: FormTypes.date,
                            width: '200px',
                            placeholder: this.$t('tip.pleaseSelect') + '${title}',
                        },
                        {
                            //title: '类别',
                            title: this.$t('tableHeader.category'),
                            key: 'punishType',
                            type: FormTypes.input,
                            width: '200px',
                            placeholder: this.$t('tip.pleaseInput') +'${title}',
                        },
                        {
                            //title: '项目',
                            title: this.$t('tableHeader.item'),
                            key: 'programs',
                            type: FormTypes.input,
                            width: '200px',
                            placeholder: this.$t('tip.pleaseInput') +'${title}',
                        },
                        {
                            //title: '金额',
                            title: this.$t('tableHeader.amount'),
                            key: 'price',
                            type: FormTypes.inputNumber,
                            width: '200px',
                            placeholder: this.$t('tip.pleaseInput') +'${title}',
                        },
                        {
                            title: this.$t('tableHeader.remarks'),
                            key: 'remarks',
                            type: FormTypes.input,
                            width: '200px',
                            placeholder: this.$t('tip.pleaseInput') +'${title}',
                        },
                    ]
                },

                //费用项
                costTable: {
                    loading: false,
                    tableName: 'efs_st_breed_settle_cost',
                    dataSource: [],
                    columns: [
                        {
                            //title: '日期',
                            title: this.$t('tableHeader.date'),
                            key: 'postDate',
                            type: FormTypes.date,
                            width: '200px',
                            placeholder: this.$t('tip.pleaseSelect') + '${title}',
                        },
                        {
                            //title: '类别',
                            title: this.$t('tableHeader.category'),
                            key: 'costType',
                            type: FormTypes.input,
                            width: '200px',
                            placeholder: this.$t('tip.pleaseInput') +'${title}',
                        },
                        {
                            //title: '项目',
                            title: this.$t('tableHeader.item'),
                            key: 'programs',
                            type: FormTypes.input,
                            width: '200px',
                            placeholder: this.$t('tip.pleaseInput') +'${title}',
                        },
                        {
                            //title: '金额',
                            title: this.$t('tableHeader.amount'),
                            key: 'price',
                            type: FormTypes.inputNumber,
                            width: '200px',
                            placeholder: this.$t('tip.pleaseInput') +'${title}',
                        },
                        {
                            title: this.$t('tableHeader.remarks'),
                            key: 'remarks',
                            type: FormTypes.input,
                            width: '200px',
                            placeholder: this.$t('tip.pleaseInput') +'${title}',
                        },
                    ]
                },

                url: {
                    add: '/settlementReceipt/efsStBreedSettle/add',
                    edit: '/settlementReceipt/efsStBreedSettle/edit',
                    queryById: '/settlementReceipt/efsMdBill/queryById',
                    getSubsidyList: '/settlementReceipt/efsStBreedSettleSubsidy/list',
                    getCostList: '/settlementReceipt/efsStBreedSettleCost/list',
                    getPunishList: '/settlementReceipt/efsStBreedSettlePunish/list',
                    efs_st_breed_settle_settlement: {
                        getMarginBalanceByBreedCode: '/depositRecord/efsStdMargin/queryByBatchBreed',
                        queryEfsStBreedSettleSettlementByMainId: '/settlementReceipt/efsStBreedSettle/queryEfsStBreedSettleSettlementByMainId'
                    },
                    efs_st_breed_settle_out: {
                        getBreedSettleOut: '/settlementReceipt/efsStBreedSettleOut/getBreedSettleOut',
                        queryEfsStBreedSettleOutByMainId: '/settlementReceipt/efsStBreedSettle/queryEfsStBreedSettleOutByMainId'
                    },
                    efs_st_breed_settle_expend: {
                        getBreedSettleExpend: '/settlementReceipt/efsStBreedSettleExpend/getBreedSettleExpend',
                        queryEfsStBreedSettleExpendByMainId: '/settlementReceipt/efsStBreedSettle/queryEfsStBreedSettleExpendByMainId'
                    }
                },
                initDocDate: moment(new Date()).format('YYYY-MM-DD'),
                dictBreedVarietyCode: '',
                dictBreedClassCode: '',
                breedBatchName: null,
                companyName: null,
                farmerName: null,
                conType: null,
                partyBSignDate: null
            }
        },
        props: {
            //流程表单data
            formData: {
                type: Object,
                default: () => {
                },
                required: false
            },
            //表单模式：false流程表单 true普通表单
            formBpm: {
                type: Boolean,
                default: false,
                required: false
            },
            //表单禁用
            disabled: {
                type: Boolean,
                default: false,
                required: false
            }
        },
        computed: {
            formDisabled() {
                if (this.formBpm === true) {
                    if (this.formData.disabled === false) {
                        return false
                    }
                    return true
                }
                return this.disabled
            },
            showFlowSubmitButton() {
                if (this.formBpm === true) {
                    if (this.formData.disabled === false) {
                        return true
                    }
                }
                return false
            }
        },
        created() {
            //如果是流程中表单，则需要加载流程表单data
            this.showFlowData()
        },
        methods: {
            addBefore() {
                getBreedCodeData().then((res) => {
                    if (res.success) {
                        this.breedCodeList = res.result
                    }
                })
                this.$refs.settleOutListForm.clearFormData()
                this.$refs.settleExpendListFrom.clearFormData()
                this.$refs.settleSettlementListFrom.clearFormData()
                this.form.resetFields()
                this.subsidyTable.dataSource = []
                this.punishTable.dataSource = []
                this.costTable.dataSource = []
            },
            getAllTable() {
                let values = this.tableKeys.map(key => getRefPromise(this, key))
                return Promise.all(values)
            },
            /** 调用完edit()方法之后会自动调用此方法 */
            editAfter() {
                let fieldval = pick(this.model, 'breedBatchCode', 'breedBatchName', 'conCode', 'settleDate', 'companyCode','farmerCode', 'conType', 'signDate', 'applyUser', 'breedClassCode', 'breedVarietyCode', 'serviceGroup', 'remarks', 'recoverPrice', 'costPrice', 'cooperMode')
                this.$nextTick(() => {
                    this.form.setFieldsValue(fieldval)
                })
                // 加载子表数据
                if (this.model.id) {
                    let params = { settleId: this.model.id }
                    this.requestSubTableData(this.url.getSubsidyList, params, this.subsidyTable)
                    this.requestSubTableData(this.url.getCostList, params, this.costTable)
                    this.requestSubTableData(this.url.getPunishList, params, this.punishTable)
                    this.$refs.settleOutListForm.initFormData(this.url.efs_st_breed_settle_out.queryEfsStBreedSettleOutByMainId, this.model.id)
                    this.$refs.settleExpendListFrom.initFormData(this.url.efs_st_breed_settle_expend.queryEfsStBreedSettleExpendByMainId, this.model.id)
                    this.$refs.settleSettlementListFrom.initFormData(this.url.efs_st_breed_settle_settlement.queryEfsStBreedSettleSettlementByMainId, this.model.id)
                    this.dictBreedVarietyCode = 'sys_category,name,code,pid=(select id from sys_category where code= \'' + this.model.breedClassCode + '\')';
                    this.dictBreedClassCode = 'sys_category,name,code,code=\'' + this.model.breedClassCode + '\'';
                }
            },
            /** 整理成formData */
            classifyIntoFormData(allValues) {
                let main = Object.assign(this.model, allValues.formValue)
                return {
                    ...main, // 展开
                    efsStBreedSettleOutList: this.$refs.settleOutListForm.getFormData(),
                    efsStBreedSettleExpendList: this.$refs.settleExpendListFrom.getFormData(),
                    efsStBreedSettleSettlementList: this.$refs.settleSettlementListFrom.getFormData(),
                    efsStBreedSettleSubsidyList: allValues.tablesValue[0].values,
                    efsStBreedSettleCostList: allValues.tablesValue[1].values,
                    efsStBreedSettlePunishList: allValues.tablesValue[2].values,
                }
            },
            //渲染流程表单数据
            showFlowData() {
                if (this.formBpm === true) {
                    let params = { id: this.formData.dataId }
                    getAction(this.url.queryById, params).then((res) => {
                        if (res.success) {
                            this.edit(res.result)
                        }
                    })
                }
            },
            validateError(msg) {
                this.$message.error(msg)
            },
            breedCodeChanged(code) {
                //提取主数据
                getAction('/settlementReceipt/efsStBreedSettle/getBreedVo', { breedCode: code }).then(res => {
                    if (res.success) {
                        this.form.resetFields()
                        this.form.setFieldsValue({
                            breedBatchCode: res.result.breedBatchCode,
                            breedBatchName: res.result.breedBatchName,
                            conCode: res.result.conCode,
                            conType: res.result.conType,
                            signDate: res.result.signDate,
                            breedVarietyCode: res.result.breedVarietyCode,
                            breedClassCode: res.result.breedClassCode,
                            companyCode: res.result.companyCode,
                            farmerCode: res.result.farmerCode,
                            applyUser: res.result.applyUser,
                            serviceGroup: res.result.serviceGroup,
                            cooperMode: res.result.cooperMode,
                        })
                        this.dictBreedVarietyCode = 'sys_category,name,code,pid=(select id from sys_category where code= \'' + res.result.breedClassCode + '\')';
                        this.dictBreedClassCode = 'sys_category,name,code,code=\'' + res.result.breedClassCode + '\'';
                        this.$bus.$emit("cooperModeEmit", res.result.cooperMode);
                    } else {
                        this.$message.warning(res.message);
                    }
                })
                this.$refs.settleOutListForm.formDataByBreedCode(this.url.efs_st_breed_settle_out.getBreedSettleOut, code)
                this.$refs.settleExpendListFrom.formDataByBreedCode(this.url.efs_st_breed_settle_expend.getBreedSettleExpend, code)
                this.$refs.settleSettlementListFrom.formDataByBreedCode(this.url.efs_st_breed_settle_settlement.getMarginBalanceByBreedCode, code)
            },
            /** 确定按钮点击事件 */
            handleOk() {
                if (this.$refs.settleOutListForm.getFormData().length == 0) {
                    this.$message.error(this.$t('tip.theBatchDoesNotHaveTheDeliveryInformation'))
                    return
                }
                if (this.$refs.settleExpendListFrom.getFormData().length == 0) {
                    this.$message.error(this.$t('tip.noConsumptionInformationForThisBatch'))
                    return
                }
                if (this.$refs.settleSettlementListFrom.getFormData().length == 0) {
                    this.$message.error(this.$t('tip.theVerificationOfTheBatchDetailsDidNotPass'))
                    return
                }
                /** 触发表单验证 */
                this.getAllTable().then(tables => {
                    /** 一次性验证主表和所有的次表 */
                    return validateFormAndTables(this.form, tables)
                }).then(allValues => {
                    if (typeof this.classifyIntoFormData !== 'function') {
                        throw this.throwNotFunction('classifyIntoFormData')
                    }
                    let formData = this.classifyIntoFormData(allValues)
                    // 发起请求
                    return this.request(formData)
                }).catch(e => {
                    if (e.error === VALIDATE_NO_PASSED) {
                        // 如果有未通过表单验证的子表，就自动跳转到它所在的tab
                        this.activeKey = e.index == null ? this.activeKey : this.refKeys[e.index]
                    } else {
                        console.error(e)
                    }
                })
            },
            subsidyTableHandleValueChange(event) {
                let priceSum = 0
                let data = this.$refs[this.refKeys[2]].getValuesSync({ validate: false })
                data.values && data.values.length && data.values.map(item => {
                    priceSum += (item.price * 1)
                })
                this.$bus.$emit("subsidyTableEmit", priceSum)
            },
            costTableHandleValueChange(event){
                let priceSum = 0
                let data = this.$refs[this.refKeys[3]].getValuesSync({ validate: false })
                data.values && data.values.length && data.values.map(item => {
                    priceSum += (item.price * 1)
                })
                this.$bus.$emit("costTableEmit", priceSum)
            },
            punishTableHandleValueChange(event){
                let priceSum = 0
                let data = this.$refs[this.refKeys[4]].getValuesSync({ validate: false })
                data.values && data.values.length && data.values.map(item => {
                    priceSum += (item.price * 1)
                })
                this.$bus.$emit("punishTableEmit", priceSum)
            }
        }
    }
</script>

<style scoped>
</style>